import { ILayoutState } from '../../types';
import { Types } from '../actions/layout-actions';

const layoutReducer = (state: ILayoutState, action: any): ILayoutState => {
  switch (action.type) {
    case Types.TOGGLE_SIDEBAR:
      return { ...state, expanded: action.data };
    case Types.SHOW_SESSION_EXPIRED_MODAL:
      return { ...state, isSessionExpired: true };
    default:
      return state;
  }
};

export default layoutReducer;
